var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsNumber } from 'class-validator';
/**
 * How many active patient programmes and library templates currently reference
 * an exercise. Shown on the delete-confirmation screen so the user sees the
 * impact before removing the exercise from them.
 */
export class ExerciseUsageDto {
    /** Number of distinct patient programmes (userId NOT NULL) using the exercise. */
    programmeCount;
    /** Number of distinct library templates (userId NULL) using the exercise. */
    templateCount;
}
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseUsageDto.prototype, "programmeCount", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseUsageDto.prototype, "templateCount", void 0);
//# sourceMappingURL=exercise-usage.dto.js.map